// extracted by mini-css-extract-plugin
export default {"container":"assistant_container__4CpBn","name":"assistant_name__iRE0x"};